export default "__VITE_ASSET__82dc2a07__"